import { action } from 'typesafe-actions';
import { STORE_RENDER_FORM_TRIGGER, CLEAR_RENDER_FORM_TRIGGER } from '../constants/Constants';

export const storeRenderFormTrigger = (triggerName: string) => action(STORE_RENDER_FORM_TRIGGER, 
  {
    triggerName : triggerName
  });

export const clearRenderFormTrigger = () => action(CLEAR_RENDER_FORM_TRIGGER); 